import dayjs from 'dayjs'

export const TOKEN_KEY = 'token'

export const HYB_DEV_ENV = 'hyb_dev_env'

export const USER_DATA_KEY = 'userData'

export const COMPANY_LIST_KEY = 'CompanyList'

export const ACTIVE_COMPANY_KEY = 'ActiveCompany'

export const LOGIN_INFO_KEY = 'loginInfo'

export const CORRELATED_SAAS_KEY = 'correlatedSaas'

export const PHONE_KEY = 'phone'

/**
 * 日期选择最大值,当前日期后100年
 */
export const DATEPICKER_MAX = dayjs().add(100, 'year').endOf('year').toDate()

/**
 * 日期选择最小值,当前日期前100年
 */
export const DATEPICKER_MIN = dayjs().subtract(100, 'year').startOf('year').toDate()

/**
 *  日期默认值最小值(1960-01-01)
 */
export const DATEPICKER_MIN_DEFAULT_STRING = '1900-01-01'

/**
 *  日期默认值最小值(1960-01-01)时间戳
 */
export const DATEPICKER_MIN_DEFAULT_TIMESTAMP = dayjs(DATEPICKER_MIN_DEFAULT_STRING).valueOf()

// 日期默认值最小日期
export const DATEPICKER_MIN_DEFAULT_DATE = dayjs(DATEPICKER_MIN_DEFAULT_STRING).toDate()

/**
 * HCalendarPicker 日期范围 两年
 */
const CALENDARPICKER_RANGE_NUMBER = 2

/**
 * HCalendarPicker 最小日期 两年前
 */
export const CALENDARPICKER_MIN_DATE = dayjs()
  .subtract(CALENDARPICKER_RANGE_NUMBER, 'year')
  .startOf('year')
  .toDate()

/**
 * HCalendarPicker 最大日期 两年后
 */
export const CALENDARPICKER_MAX_DATE = dayjs()
  .add(CALENDARPICKER_RANGE_NUMBER, 'year')
  .endOf('year')
  .toDate()

export * as QUERY_KEY_MAP from './queryKey'

// 表单状态
export const StatusCode = {
  pending: 'PENDING',
  done: 'DONE',
  error: 'ERROR'
}

// 租户ID
export const TENANT_ID_MAP = {
  // 福朋喜来登
  xilaideng: 11142,
  // 黑河港务局（QA)
  heihe_test: 10759,
  // Testdata测试企微
  Testdata_wx: 11095,
  // 测试迁移01
  TestMigration01: 11111
}

// 选择组件模式
export const SELECT_MODE = {
  /** 单选 */
  SINGLE: 'single',
  /** 多选 */
  MULTIPLE: 'multiple',
  /** 查看 */
  VIEW: 'view'
}

// 组件分类
export const CATEGORY_INFO_MAP: Record<string, { label: string; category: string }> = {
  /** 组织 */
  Organize: {
    label: '组织',
    /** 组织 */
    category: 'Organize'
  },
  /** 成本中心 */
  CostCenter: {
    label: '成本中心',
    /** 成本中心 */
    category: 'CostCenter'
  },
  Personnel: {
    label: '人员',
    /** 人员 */
    category: 'Personnel'
  }
}

/** 颜色透明度 */
export const COLOR_TRANSPARENCY = {
  /** 20% 透明度 */
  LEVEL_1: 0.2,
  /** 30% 透明度 */
  LEVEL_2: 0.3,
  /** 40% 透明度 */
  LEVEL_3: 0.4,
  /** 50% 透明度 */
  LEVEL_4: 0.5
}

export const LANGUAGE_MODE = {
  /** 中文 */
  ZH: 'zh',
  /** 英文 */
  EN: 'en'
}

/** 时间单位 */
export const TIME_UNIT_MAP = {
  [LANGUAGE_MODE.ZH]: {
    hour: '小时',
    minute: '分钟'
  },
  [LANGUAGE_MODE.EN]: {
    hour: 'h',
    minute: 'm'
  }
}

/** 异动OA  异动/降级/晋升/调岗/异动调薪 */
export const OA_CHANGE_TYPE_LIST = [
  'SYSTEM_CHANGE',
  'SYSTEM_DEMOTION',
  'SYSTEM_PROMOTION',
  'SYSTEM_JOB_TRANSFER',
  'SYSTEM_SALARY_ADJUSTMENT'
]
